import React from "react";
import "./Login.component.css";
import { Form, Checkbox } from "informed";
import EditText from "../common/form-fields/edit-text/EditText";
import EditPassword from "../common/form-fields/edit-text/EditPassword";
import { SIGN_IN, FORGOT_PASSWORD, CREATE_PASSWORD } from "./LoginPage";
import Loader from "./../common/loader/Loader";
//import { msalInstance } from "./index";
import { Link } from "react-router-dom";

const validate = value => {
  return value && value.length > 0 && !validateEmail(value)
    ? "Please enter a valid email address"
    : null;
};

const validateEmail = email => {
  var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const CreateResetPassword = props => {
  const createPassword = values => {
    props.createPasswordClick(values.email);
  };

  return (
    <div className="sign-in-box rounded">
      <div className="title-green">{props.title}</div>
      <label className="title-description">{props.description}</label>
      <Form onSubmit={values => createPassword(values)}>
        {({ formState }) => (
          <React.Fragment>
            <EditText
              required
              email
              id="create_reset_email_address"
              showError={props.loginError ? true : false}
              showErrorText={"Invalid email. Please correct."}
              className="margin-bottom"
              field="email"
              type="text"
              title="Email Address"
              validate={validate}
              validateOnBlur
              validateOnChange
              floatingTitle={true}
              disabled={props.fetching}
              onClick={e => {
                props.resetErrorHandler(e);
              }}
            />

            <button
              type="submit"
              id="create_reset_button"
              className="button-primary send-Password-container"
              disabled={props.fetching || props.loginError || formState.invalid}
            >
              Submit
            </button>
            {/* Redirect the user to the root domain when the user clicks the back to sign in button */}
            <div className="back-to-signin-container d-flex flex-row align-items-center justify-content-center">
              <a href={window.location.origin} id="back_to_signin_button" 
                  className="forgot-password col-xs-12 col-sm-6 mx-auto no-padding"
              >
                Back to Sign-In
              </a>
            </div>

            <div className="create-password-container" />
          </React.Fragment>
        )}
      </Form>

      <LoadingOverlay fetching={props.fetching} />
    </div>
  );
};

export const PasswordSent = props => {
  return (
    <div className="sign-in-box password-sent-box rounded d-flex flex-column justify-content-center align-items-center">
      <img
        alt="success"
        className="success_logo"
        src="/assets/images/login/success.png"
      />
      <div className="title-green title-green-center">Success!</div>
      <label className="title-description w-100">
        An email has been sent with a link to reset your password. Link will expire in 15 minutes.
      </label>

      <div className="back-to-signin-container justify-content-center">
        <a href={window.location.origin} id="back_to_signin_button" 
          className="forgot-password col-xs-12 col-sm-6 mx-auto no-padding"
        >
          Back to Sign-In
        </a>
      </div>
    </div>
  );
};

const LoadingOverlay = props => {
  if (props.fetching)
    return (
      <Loader position="absolute" height="50px" width="50px"/>
    );
  else return null;
};
